import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeTeacherResourceActivityFields {
  name: EntryFieldTypes.Symbol
  slug: EntryFieldTypes.Symbol
  path?: EntryFieldTypes.Symbol
  description?: EntryFieldTypes.Text
  src?: EntryFieldTypes.Symbol
  domains: EntryFieldTypes.Array<
    EntryFieldTypes.Symbol<'all' | 'au' | 'ca' | 'cn' | 'in' | 'kr' | 'nz' | 'th' | 'uk' | 'us' | 'za'>
  >
}

export type TypeTeacherResourceActivitySkeleton = EntrySkeletonType<
  TypeTeacherResourceActivityFields,
  'teacherResourceActivity'
>
export type TypeTeacherResourceActivity<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypeTeacherResourceActivitySkeleton, Modifiers, Locales>

export function isTypeTeacherResourceActivity<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeTeacherResourceActivity<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'teacherResourceActivity'
}

export type TypeTeacherResourceActivityWithoutLinkResolutionResponse =
  TypeTeacherResourceActivity<'WITHOUT_LINK_RESOLUTION'>
export type TypeTeacherResourceActivityWithoutUnresolvableLinksResponse =
  TypeTeacherResourceActivity<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeTeacherResourceActivityWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> =
  TypeTeacherResourceActivity<'WITH_ALL_LOCALES', Locales>
export type TypeTeacherResourceActivityWithAllLocalesAndWithoutLinkResolutionResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeTeacherResourceActivity<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeTeacherResourceActivityWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeTeacherResourceActivity<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
